/* BMI calculator (sections/bmi-calculator.liquid). Vanilla JS, runs per widget, stores/sends nothing.
   Cut-offs: Asia-Pacific / Indian adults - underweight < 18.5, healthy 18.5-22.9, overweight 23-24.9, obese >= 25. */
(function () {
  'use strict';

  var CATS = {
    under: {
      label: 'Underweight',
      advice: 'Your BMI is below the healthy range. If you have lost weight without trying, it is worth mentioning to your doctor.',
      diabetes: 'Being underweight does not protect against diabetes. Unexplained weight loss together with constant thirst or frequent urination can be a sign of high blood sugar, so get your blood sugar checked.'
    },
    healthy: {
      label: 'Healthy range',
      advice: 'Your BMI is within the healthy range for Asian adults. Balanced meals and regular activity help you stay there.',
      diabetes: 'A healthy BMI is linked with the lowest risk of type 2 diabetes. Risk also depends on age, family history and waist size, so a yearly blood sugar check is still sensible after 30.'
    },
    over: {
      label: 'Overweight',
      advice: 'Your BMI is above the healthy range. Small, steady changes to food and activity can help - your doctor can tell you what is right for you.',
      diabetes: 'Extra body fat, especially around the waist, makes the body less responsive to insulin and raises the risk of type 2 diabetes. Asians develop diabetes at lower BMIs, which is why this range matters. Losing even 5-7% of your weight lowers that risk. Ask your doctor about a fasting sugar or HbA1c test.'
    },
    obese: {
      label: 'Obese range',
      advice: 'A higher BMI is linked with a greater risk of type 2 diabetes and heart disease. Talking to your doctor about your weight is a good next step.',
      diabetes: 'At this BMI the body is often less responsive to insulin, and the risk of developing type 2 diabetes is clearly higher. If you already have diabetes, excess weight makes blood sugar harder to control. Losing 5-7% of your weight improves insulin response. Please get your fasting sugar or HbA1c checked.'
    }
  };

  function category(bmi) {
    if (bmi < 18.5) return 'under';
    if (bmi < 23) return 'healthy';
    if (bmi < 25) return 'over';
    return 'obese';
  }

  /* Position on the gauge (15 -> 35 BMI), as a percentage */
  function gaugePos(bmi) {
    var c = Math.min(35, Math.max(15, bmi));
    return ((c - 15) / 20) * 100;
  }

  function init(root) {
    if (root.__bmiReady) return;
    root.__bmiReady = true;

    var ht = root.querySelector('[data-bmi-ht]');
    var wt = root.querySelector('[data-bmi-wt]');
    var htOut = root.querySelector('[data-bmi-ht-out]');
    var wtOut = root.querySelector('[data-bmi-wt-out]');
    var chip = root.querySelector('[data-bmi-chip]');
    var dEl = root.querySelector('[data-bmi-diabetes]');
    var reco = root.querySelector('[data-bmi-reco]');
    var recoMin = parseFloat(root.getAttribute('data-bmi-reco-min')) || 25;

    function paint(input) {
      var min = parseFloat(input.min), max = parseFloat(input.max);
      input.style.setProperty('--fill', ((parseFloat(input.value) - min) / (max - min)) * 100 + '%');
    }

    function update() {
      var inches = parseInt(ht.value, 10);
      var kg = parseFloat(wt.value);
      var feet = Math.floor(inches / 12), rem = inches % 12;
      htOut.textContent = feet + ' ft ' + rem + ' in';
      ht.setAttribute('aria-valuetext', feet + ' feet ' + rem + ' inches');
      wtOut.textContent = kg + ' kg';
      wt.setAttribute('aria-valuetext', kg + ' kilograms');
      paint(ht); paint(wt);

      var m = (inches * 2.54) / 100;
      var bmi = kg / (m * m);
      var key = category(bmi);
      var cat = CATS[key];

      root.querySelector('[data-bmi-value]').textContent = bmi.toFixed(1);
      chip.textContent = cat.label;
      chip.className = 'sk-bmi__chip sk-bmi__chip--' + key;
      root.querySelector('[data-bmi-marker]').style.left = gaugePos(bmi) + '%';
      root.querySelector('[data-bmi-advice]').textContent = cat.advice;
      if (dEl) dEl.textContent = cat.diabetes;
      if (reco) reco.hidden = bmi < recoMin;

      var lo = 18.5 * m * m, hi = 22.9 * m * m;
      root.querySelector('[data-bmi-range]').textContent =
        'A healthy weight for your height is about ' + Math.round(lo) + ' - ' + Math.round(hi) + ' kg.';
    }

    ht.addEventListener('input', update);
    wt.addEventListener('input', update);
    update();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bmi]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* theme editor: re-init sections that are added or re-rendered */
  document.addEventListener('shopify:section:load', boot);
})();
